export function getSplitLink(address: string): string {
    return `https://app.0xsplits.xyz/accounts/${address}`;
}
